import { render, staticRenderFns } from "./ContentCollection.vue?vue&type=template&id=613ca3a4&scoped=true"
import script from "./ContentCollection.vue?vue&type=script&lang=js"
export * from "./ContentCollection.vue?vue&type=script&lang=js"
import style0 from "./ContentCollection.vue?vue&type=style&index=0&id=613ca3a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613ca3a4",
  null
  
)

export default component.exports